import React, { useState } from 'react';
import { Button, Card, CardContent, Container, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import RHFTextArea from '../../components/hook-form/RHFTextArea';
import { useLoadingContext } from '../../context/loadingContext';
import { MemberService } from '../../Services/member.service';

const memberCardSchema = Yup.object().shape({
  code: Yup.string().required('Mã thẻ không được để trống'),
});

const CreateMemberCard = () => {
  const navigate = useNavigate();
  const [image, setImage] = useState();
  const [imageReview, setImageReview] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [textField, setTextField] = useState(['', '']);

  const { handleStartLoading, handleStopLoading } = useLoadingContext();

  const methods = useForm({
    resolver: yupResolver(memberCardSchema),
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleOnSubmit = (data) => {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('code', data.code);
    formData.append('description', data.description);
    textField.forEach((item) => {
      if (item && item.length > 0) formData.append('gift', item);
    });
    handleStartLoading();
    MemberService.CreateMemberCard(formData)
      .then((res) => {
        navigate(`/member/view/${res}`, { replace: true, state: '/member' });
        enqueueSnackbar('Thêm thẻ thành viên mới thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading);
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  const handleAvatarChange = (e) => {
    const img = e.target.files[0];
    const review = URL.createObjectURL(img);
    setImageReview(review);
    setImage(img);
  };

  const handleTextFieldChange = (index, event) => {
    const data = [...textField];
    data[index] = event.target.value;
    setTextField(data);
  };

  const handleAddRow = () => {
    setTextField((prevState) => [...prevState, '']);
  };

  const handleRemove = (index) => {
    const data = [...textField];
    data.splice(index, 1);
    setTextField(data);
  };

  return (
    <Page title="Create event">
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Thêm thẻ thành viên
            </Typography>
            <Stack direction={'row'} spacing={1}>
              <Button
                type="button"
                onClick={handleCancelClick}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="iconoir:cancel" />}
              >
                Cancel
              </Button>
              <Button disabled={isSubmitting} type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                Save
              </Button>
            </Stack>
          </Stack>
          <Card>
            <CardContent>
              <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                <Grid item xs={12} md={8}>
                  <Stack spacing={3}>
                    <RHFTextField name="code" label={'Mã thẻ'} />
                    <RHFTextArea name="description" label={'Mô tả'} />
                    <Typography variant="h4" gutterBottom>
                      Ưu đãi
                    </Typography>
                    {textField.map((item, index) => (
                      <Stack direction={'row'}>
                        <TextField
                          fullWidth
                          multiline
                          rows={2}
                          key={index}
                          value={item}
                          label={`Ưu đãi ${index + 1}`}
                          onChange={(e) => handleTextFieldChange(index, e)}
                        />
                        <IconButton
                          sx={{
                            ':hover': {
                              background: 'none',
                            },
                            color: '#c0392b',
                          }}
                          aria-label="delete"
                          size="large"
                          onClick={() => handleRemove(index)}
                        >
                          <Iconify icon="material-symbols:delete-rounded" />
                        </IconButton>
                      </Stack>
                    ))}
                    <Button onClick={handleAddRow}>Thêm ưu đãi</Button>
                  </Stack>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    disabled={isSubmitting}
                    sx={{ border: '1px dashed gray' }}
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input onChange={handleAvatarChange} hidden accept="image/*" type="file" />
                    {imageReview ? (
                      <img
                        src={imageReview}
                        alt="noimage"
                        width={'300px'}
                        height={'170px'}
                        style={{ objectFit: 'cover' }}
                      />
                    ) : (
                      <img
                        src="/static/noimage.jpeg"
                        alt="noimage"
                        width={'300px'}
                        height={'180px'}
                        style={{ objectFit: 'cover' }}
                      />
                    )}
                  </Button>
                  <Typography variant="body2" display="block" sx={{opacity: '0.6'}}>Kích thước: 530x300</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </FormProvider>
    </Page>
  );
};

export default CreateMemberCard;
